module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', [_vm._h('div', {
    staticClass: "col-xs-12 col-sm-10 col-md-8 col-lg-8"
  }, [_vm._h('chart', {
    attrs: {
      "bike-data": _vm.bikes
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2dadc950!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Data.vue
// module id = 15
// module chunks = 1